export const resolveLabel = (code, list) => {
  if (!code || !Array.isArray(list)) return 'N/A';
  return list.find((i) => i.code === code)?.label || code;
};

/* ================= VENTURE_TYPE ================= */

export const VENTURE_TYPE_CODES = [
  {
    tier: '131',
    class: '1311',
    code: '131100',
    category: 'Token Classification',
    subClass: 'Token Type',
    label: 'Select Token Type',
    inputType: 'single-select',
    options: [
      'Composite Asset Token',
      'Revenue-Linked Token',
      'Equity-Linked Token',
      'Debt-Linked Token',
      'Project-Level Token',
      'Commodity-Linked Token',
      'Hybrid Token'
    ]
  },

  /* ----------------------------- */
  /*      COMPOSITE ASSET TOKENS   */
  /* ----------------------------- */

  {
    tier: '131',
    class: '1311',
    code: '131101',
    category: 'Composite Asset Tokens',
    subClass: 'Multi-Asset Composite',
    label: 'Multi-Asset Composite Token',
    inputType: 'select',
    visibleIf: { field: '131100', equals: 'Composite Asset Token' }
  },
  {
    tier: '131',
    class: '1311',
    code: '131102',
    category: 'Composite Asset Tokens',
    subClass: 'Commodity Basket',
    label: 'Commodity Basket Token',
    inputType: 'select',
    visibleIf: { field: '131100', equals: 'Composite Asset Token' }
  },
  {
    tier: '131',
    class: '1311',
    code: '131103',
    category: 'Composite Asset Tokens',
    subClass: 'Digital Asset Index',
    label: 'Digital Asset Index Token',
    inputType: 'select',
    visibleIf: { field: '131100', equals: 'Composite Asset Token' }
  },
  {
    tier: '131',
    class: '1311',
    code: '131104',
    category: 'Composite Asset Tokens',
    subClass: 'Sector Thematic',
    label: 'Sector-Thematic Composite Token',
    inputType: 'select',
    visibleIf: { field: '131100', equals: 'Composite Asset Token' }
  },
  {
    tier: '131',
    class: '1311',
    code: '131105',
    category: 'Composite Asset Tokens',
    subClass: 'Yield Strategy',
    label: 'Yield-Strategy Composite Token',
    inputType: 'select',
    visibleIf: { field: '131100', equals: 'Composite Asset Token' }
  },
  {
    tier: '131',
    class: '1311',
    code: '131106',
    category: 'Composite Asset Tokens',
    subClass: 'FX Exposure',
    label: 'FX-Exposure Composite Token',
    inputType: 'select',
    visibleIf: { field: '131100', equals: 'Composite Asset Token' }
  },
  {
    tier: '131',
    class: '1311',
    code: '131107',
    category: 'Composite Asset Tokens',
    subClass: 'Cross-Asset Macro',
    label: 'Cross-Asset Macro Composite Token',
    inputType: 'select',
    visibleIf: { field: '131100', equals: 'Composite Asset Token' }
  },

  /* ----------------------------- */
  /*      REVENUE-LINKED TOKENS    */
  /* ----------------------------- */

  {
    tier: '131',
    class: '1311',
    code: '131108',
    category: 'Revenue-Linked Tokens',
    subClass: 'Gross Revenue Share',
    label: 'Gross Revenue Share Token',
    inputType: 'select',
    visibleIf: { field: '131100', equals: 'Revenue-Linked Token' }
  },
  {
    tier: '131',
    class: '1311',
    code: '131109',
    category: 'Revenue-Linked Tokens',
    subClass: 'Net Revenue Share',
    label: 'Net Revenue Share Token',
    inputType: 'select',
    visibleIf: { field: '131100', equals: 'Revenue-Linked Token' }
  },
  {
    tier: '131',
    class: '1311',
    code: '131110',
    category: 'Revenue-Linked Tokens',
    subClass: 'Royalty Stream',
    label: 'Royalty Stream Token',
    inputType: 'select',
    visibleIf: { field: '131100', equals: 'Revenue-Linked Token' }
  },
  {
    tier: '131',
    class: '1311',
    code: '131111',
    category: 'Revenue-Linked Tokens',
    subClass: 'Subscription Revenue',
    label: 'Subscription/Recurring Revenue Token',
    inputType: 'select',
    visibleIf: { field: '131100', equals: 'Revenue-Linked Token' }
  },
  {
    tier: '131',
    class: '1311',
    code: '131112',
    category: 'Revenue-Linked Tokens',
    subClass: 'Licensing Revenue',
    label: 'Licensing Revenue Token',
    inputType: 'select',
    visibleIf: { field: '131100', equals: 'Revenue-Linked Token' }
  },

  /* ----------------------------- */
  /*      EQUITY-LINKED TOKENS     */
  /* ----------------------------- */

  {
    tier: '131',
    class: '1311',
    code: '131113',
    category: 'Equity-Linked Tokens',
    subClass: 'Common Equity',
    label: 'Common Equity Token',
    inputType: 'multi-select',
    options: [
      'Common Equity',
      'Custody Type: Transfer Agent',
      'Custody Type: Broker-Dealer',
      'Custody Type: Custodial Bank',
      'Custody Type: Clearing Agency',
      'Custody Type: Trust Company'
    ],
    visibleIf: { field: '131100', equals: 'Equity-Linked Token' }
  },
  {
    tier: '131',
    class: '1311',
    code: '131114',
    category: 'Equity-Linked Tokens',
    subClass: 'Preferred Equity',
    label: 'Preferred Equity Token',
    inputType: 'multi-select',
    options: [
      'Preferred Equity',
      'Custody Type: Transfer Agent',
      'Custody Type: Broker-Dealer',
      'Custody Type: Custodial Bank',
      'Custody Type: Clearing Agency',
      'Custody Type: Trust Company'
    ],
    visibleIf: { field: '131100', equals: 'Equity-Linked Token' }
  },
  {
    tier: '131',
    class: '1311',
    code: '131115',
    category: 'Equity-Linked Tokens',
    subClass: 'Non-Voting Equity',
    label: 'Non-Voting Equity Token',
    inputType: 'multi-select',
    options: [
      'Non-Voting Equity',
      'Custody Type: Transfer Agent',
      'Custody Type: Broker-Dealer',
      'Custody Type: Custodial Bank',
      'Custody Type: Clearing Agency',
      'Custody Type: Trust Company'
    ],
    visibleIf: { field: '131100', equals: 'Equity-Linked Token' }
  },
  {
    tier: '131',
    class: '1311',
    code: '131116',
    category: 'Equity-Linked Tokens',
    subClass: 'Equity Warrant',
    label: 'Equity Warrant Token',
    inputType: 'multi-select',
    options: [
      'Equity Warrant',
      'Custody Type: Transfer Agent',
      'Custody Type: Broker-Dealer',
      'Custody Type: Custodial Bank',
      'Custody Type: Clearing Agency',
      'Custody Type: Trust Company'
    ],
    visibleIf: { field: '131100', equals: 'Equity-Linked Token' }
  },

  /* ----------------------------- */
  /*      DEBT-LINKED TOKENS       */
  /* ----------------------------- */

  {
    tier: '131',
    class: '1311',
    code: '131117',
    category: 'Debt-Linked Tokens',
    subClass: 'Fixed-Term Debt',
    label: 'Fixed-Term Debt Token',
    inputType: 'multi-select',
    options: [
      'Fixed-Term Debt',
      'Custody Type: Transfer Agent',
      'Custody Type: Broker-Dealer',
      'Custody Type: Custodial Bank',
      'Custody Type: Clearing Agency',
      'Custody Type: Trust Company'
    ],
    visibleIf: { field: '131100', equals: 'Debt-Linked Token' }
  },
  {
    tier: '131',
    class: '1311',
    code: '131118',
    category: 'Debt-Linked Tokens',
    subClass: 'Perpetual Debt',
    label: 'Perpetual Debt Token',
    inputType: 'multi-select',
    options: [
      'Perpetual Debt',
      'Custody Type: Transfer Agent',
      'Custody Type: Broker-Dealer',
      'Custody Type: Custodial Bank',
      'Custody Type: Clearing Agency',
      'Custody Type: Trust Company'
    ],
    visibleIf: { field: '131100', equals: 'Debt-Linked Token' }
  },
  {
    tier: '131',
    class: '1311',
    code: '131119',
    category: 'Debt-Linked Tokens',
    subClass: 'Convertible Debt',
    label: 'Convertible Debt Token',
    inputType: 'multi-select',
    options: [
      'Convertible Debt',
      'Custody Type: Transfer Agent',
      'Custody Type: Broker-Dealer',
      'Custody Type: Custodial Bank',
      'Custody Type: Clearing Agency',
      'Custody Type: Trust Company'
    ],
    visibleIf: { field: '131100', equals: 'Debt-Linked Token' }
  },
  {
    tier: '131',
    class: '1311',
    code: '131120',
    category: 'Debt-Linked Tokens',
    subClass: 'Senior Secured Debt',
    label: 'Senior Secured Debt Token',
    inputType: 'multi-select',
    options: [
      'Senior Secured Debt',
      'Custody Type: Transfer Agent',
      'Custody Type: Broker-Dealer',
      'Custody Type: Custodial Bank',
      'Custody Type: Clearing Agency',
      'Custody Type: Trust Company'
    ],
    visibleIf: { field: '131100', equals: 'Debt-Linked Token' }
  },
  {
    tier: '131',
    class: '1311',
    code: '131121',
    category: 'Debt-Linked Tokens',
    subClass: 'Subordinated Debt',
    label: 'Subordinated Debt Token',
    inputType: 'multi-select',
    options: [
      'Subordinated Debt',
      'Custody Type: Transfer Agent',
      'Custody Type: Broker-Dealer',
      'Custody Type: Custodial Bank',
      'Custody Type: Clearing Agency',
      'Custody Type: Trust Company'
    ],
    visibleIf: { field: '131100', equals: 'Debt-Linked Token' }
  },

  /* ----------------------------- */
  /*      PROJECT-LEVEL TOKENS     */
  /* ----------------------------- */

  {
    tier: '131',
    class: '1311',
    code: '131122',
    category: 'Project-Level Tokens',
    subClass: 'Real Estate Development',
    label: 'Real Estate Development Token',
    inputType: 'multi-select',
    options: [
      'Real Estate Development',
      'New Project: Commercial',
      'Existing Project: Commercial',
      'New Project: Multi-Family',
      'Existing Project: Multi-Family'
    ],
    visibleIf: { field: '131100', equals: 'Project-Level Token' }
  },
  {
    tier: '131',
    class: '1311',
    code: '131123',
    category: 'Project-Level Tokens',
    subClass: 'Mining Project',
    label: 'Mining/Extraction Project Token',
    inputType: 'multi-select',
    options: [
      'Precious Metals',
      'Gemstones',
      'Base Metals',
      'Battery Metals',
      'Energy Resource',
      'Industrial Minerals',
      'Bulk Commodity',
      'Critical Minerals'
    ],
    visibleIf: { field: '131100', equals: 'Project-Level Token' }
  },
  {
    tier: '131',
    class: '1311',
    code: '131124',
    category: 'Project-Level Tokens',
    subClass: 'Energy Infrastructure',
    label: 'Energy Infrastructure Token',
    inputType: 'select',
    visibleIf: { field: '131100', equals: 'Project-Level Token' }
  },
  {
    tier: '131',
    class: '1311',
    code: '131125',
    category: 'Project-Level Tokens',
    subClass: 'Film Production',
    label: 'Film/Media Production Token',
    inputType: 'select',
    visibleIf: { field: '131100', equals: 'Project-Level Token' }
  },

  /* ----------------------------- */
  /*    OPERATIONAL TOKENS         */
  /* ----------------------------- */

  {
    tier: '131',
    class: '1311',
    code: '131126',
    category: 'Operational Tokens',
    subClass: 'Inventory Backed',
    label: 'Inventory-Backed Token',
    inputType: 'select',
    visibleIf: { field: '131100', equals: 'Project-Level Token' }
  },
  {
    tier: '131',
    class: '1311',
    code: '131127',
    category: 'Operational Tokens',
    subClass: 'Supply Chain Finance',
    label: 'Supply-Chain Finance Token',
    inputType: 'select',
    visibleIf: { field: '131100', equals: 'Project-Level Token' }
  },
  {
    tier: '131',
    class: '1311',
    code: '131128',
    category: 'Operational Tokens',
    subClass: 'Equipment Financing',
    label: 'Equipment Financing Token',
    inputType: 'select',
    visibleIf: { field: '131100', equals: 'Project-Level Token' }
  },

  /* ----------------------------- */
  /*   COMMODITY-LINKED TOKENS     */
  /* ----------------------------- */

  {
    tier: '131',
    class: '1311',
    code: '131129',
    category: 'Commodity-Linked Tokens',
    subClass: 'Precious Metals Output',
    label: 'Precious Metals Production Token',
    inputType: 'multi-select',
    options: [
      'Precious Metals Production',
      'Gold Ore',
      'Silver Ore',
      'Platinum Ore',
      'Palladium Ore',
      'PGM Mixed Ore',
      'By-Product Production'
    ],
    visibleIf: { field: '131100', equals: 'Commodity-Linked Token' }
  },
  {
    tier: '131',
    class: '1311',
    code: '131130',
    category: 'Commodity-Linked Tokens',
    subClass: 'Petroleum Output',
    label: 'Petroleum Output Token',
    inputType: 'multi-select',
    options: [
      'Petroleum Output',
      'Light Sweet Crude',
      'Light Sour Crude',
      'Medium Crude',
      'Heavy Crude',
      'Extra-Heavy Crude',
      'Bitumen',
      'Condensate'
    ],
    visibleIf: { field: '131100', equals: 'Commodity-Linked Token' }
  },
  {
    tier: '131',
    class: '1311',
    code: '131131',
    category: 'Commodity-Linked Tokens',
    subClass: 'Agricultural Production',
    label: 'Agricultural Token',
    inputType: 'multi-select',
    options: [
      'Agricultural Production',
      'Maize',
      'Wheat',
      'Cocoa',
      'Soybeans',
      'Sugar',
      'Coffee',
      'Cotton'
    ],
    visibleIf: { field: '131100', equals: 'Commodity-Linked Token' }
  },

  /* ----------------------------- */
  /*      IP & LICENSING TOKENS    */
  /* ----------------------------- */

  {
    tier: '131',
    class: '1311',
    code: '131132',
    category: 'IP & Licensing Tokens',
    subClass: 'IP Licensing',
    label: 'IP Licensing Token',
    inputType: 'select',
    visibleIf: { field: '131100', equals: 'IP & Licensing Token' }
  },
  {
    tier: '131',
    class: '1311',
    code: '131133',
    category: 'IP & Licensing Tokens',
    subClass: 'Royalty Rights',
    label: 'Music/Film Royalty Token',
    inputType: 'select',
    visibleIf: { field: '131100', equals: 'IP & Licensing Token' }
  },

  /* ----------------------------- */
  /*          HYBRID TOKENS        */
  /* ----------------------------- */

  {
    tier: '131',
    class: '1311',
    code: '131134',
    category: 'Hybrid Tokens',
    subClass: 'Equity + Revenue',
    label: 'Equity + Revenue Hybrid Token',
    inputType: 'select',
    visibleIf: { field: '131100', equals: 'Hybrid Token' }
  },
  {
    tier: '131',
    class: '1311',
    code: '131135',
    category: 'Hybrid Tokens',
    subClass: 'Debt + Revenue',
    label: 'Debt + Revenue Hybrid Token',
    inputType: 'select',
    visibleIf: { field: '131100', equals: 'Hybrid Token' }
  }
];

/* ================= ISSUER_TYPE ================= */

export const ISSUER_TYPE_CODES = [
  {
    tier: '131',
    class: '1311',
    code: '131101',
    category: 'Corporate Structure',
    subClass: 'Parent Company',
    label: 'Parent Entity',
    inputType: 'single-select',
    options: ['Verified', 'Not Verified']
  },
  {
    tier: '131',
    class: '1311',
    code: '131102',
    category: 'Corporate Structure',
    subClass: 'Subsidiaries',
    label: 'Subsidiaries / SPVs',
    inputType: 'single-select',
    options: [
      'None',
      'Domestic Subsidiary',
      'Foreign Subsidiary',
      'Offshore Subsidiary',
      'Special Economic Zone Subsidiary'
    ]
  },
  {
    tier: '131',
    class: '1311',
    code: '131103',
    category: 'Corporate Structure',
    subClass: 'Board',
    label: 'Board of Directors',
    inputType: 'single-select',
    options: [
      'None',
      'Appointed Directors',
      'Elected Directors',
      'Investor Designated Directors',
      'Special Economic Zone Subsidiary'
    ]
  },
  {
    tier: '131',
    class: '1311',
    code: '131104',
    category: 'Corporate Structure',
    subClass: 'Executives',
    label: 'Executive Team',
    inputType: 'single-select',
    options: ['Current', 'Not Current']
  },
  {
    tier: '131',
    class: '1311',
    code: '131105',
    category: 'Corporate Structure',
    subClass: 'Governance Model',
    label: 'Traditional/DAO/Hybrid',
    inputType: 'single-select',
    options: [
      'None',
      'Traditional',
      'DAO',
      'Hybrid Goverance',
      'Board Managed',
      'Member Managed'
    ]
  },
  {
    tier: '131',
    class: '1311',
    code: '131106',
    category: 'Corporate Structure',
    subClass: 'Voting Rights',
    label: 'Voting Rights Structure',
    inputType: 'single-select',
    options: [
      'None',
      'Token Weighted Voting',
      'One Share One Vote',
      'Dual Class Voting',
      'Multi-Class Voting',
      'Quadratic Voting',
      'Board Only Voting',
      'Investor Reserved Voting'
    ]
  },
  {
    tier: '131',
    class: '1311',
    code: '131107',
    category: 'Corporate Structure',
    subClass: 'Token Classes',
    label: 'Token Class Structure',
    inputType: 'single-select',
    options: [
      'None',
      'Equity Class',
      'Debt Class',
      'Hybrid Class',
      'Revenue Share Class',
      'Royalty Class',
      'Utility Class',
      'Governance Class'
    ]
  },
  {
    tier: '131',
    class: '1311',
    code: '131108',
    category: 'Corporate Structure',
    subClass: 'Ownership',
    label: 'Token Ownership Breakdown',
    inputType: 'single-select',
    options: [
      'None',
      'General Token Holders',
      'Preferred Token Holders',
      'Non-Voting Token Holders',
      'Revenue Share Token Holders',
      'Debt Token Holders'
    ]
  },
  {
    tier: '131',
    class: '1311',
    code: '131109',
    category: 'Corporate Structure',
    subClass: 'Insider Holdings',
    label: 'Insider Holdings',
    inputType: 'single-select',
    options: [
      'Majority Holders (>50%)',
      'Significant Minority Holder (20-50%)',
      'Minority Holder (<20%)',
      'Widely Distributed Holders'
    ]
  },
  {
    tier: '131',
    class: '1311',
    code: '131110',
    category: 'Corporate Structure',
    subClass: 'Insider Lockups',
    label: 'Insider Lockup Terms',
    inputType: 'single-select',
    options: [
      'None',
      '12 months',
      '24 months',
      '36 months',
      '48 months',
      '60 months'
    ]
  }
];

/* ================= ISSUER_IDENTIFIER ================= */

export const ISSUER_INDENTIFIER_CODES = [
  {
    tier: '130',
    class: '1301',
    code: '130101',
    category: 'Issuer Identification',
    subClass: 'Legal Name',
    label: 'Issuer Name',
    inputType: 'text'
  },
  {
    tier: '130',
    class: '1301',
    code: '130102',
    category: 'Issuer Identification',
    subClass: 'Short Name',
    label: 'Issuer Short Name',
    inputType: 'text'
  },
  {
    tier: '130',
    class: '1301',
    code: '130103',
    category: 'Issuer Identification',
    subClass: 'Ticker',
    label: 'Issuer Token Symbol',
    inputType: 'text'
  },
  {
    tier: '130',
    class: '1301',
    code: '130104',
    category: 'Issuer Identification',
    subClass: 'Entity Type',
    label: 'Entity Type',
    inputType: 'select',
    options: ['Corporation', 'LLC', 'DAO', 'Foundation', 'SPV']
  },

  {
    tier: '130',
    class: '1301',
    code: '130105',
    category: 'Issuer Identification',
    subClass: 'Country',
    label: 'Country',
    inputType: 'select',
    options: [
      'Afghanistan',
      'Albania',
      'Algeria',
      'Andorra',
      'Angola',
      'Antigua and Barbuda',
      'Argentina',
      'Armenia',
      'Australia',
      'Austria',
      'Azerbaijan',
      'Bahamas',
      'Bahrain',
      'Bangladesh',
      'Barbados',
      'Belarus',
      'Belgium',
      'Belize',
      'Benin',
      'Bhutan',
      'Bolivia',
      'Bosnia and Herzegovina',
      'Botswana',
      'Brazil',
      'Brunei',
      'Bulgaria',
      'Burkina Faso',
      'Burundi',
      'Cambodia',
      'Cameroon',
      'Canada',
      'Cape Verde',
      'Central African Republic',
      'Chad',
      'Chile',
      'China',
      'Colombia',
      'Comoros',
      'Congo (Republic of the)',
      'Congo (Democratic Republic of the)',
      'Costa Rica',
      'Croatia',
      'Cuba',
      'Cyprus',
      'Czech Republic',
      'Denmark',
      'Djibouti',
      'Dominica',
      'Dominican Republic',
      'Ecuador',
      'Egypt',
      'El Salvador',
      'Equatorial Guinea',
      'Eritrea',
      'Estonia',
      'Eswatini',
      'Ethiopia',
      'Fiji',
      'Finland',
      'France',
      'Gabon',
      'Gambia',
      'Georgia',
      'Germany',
      'Ghana',
      'Greece',
      'Grenada',
      'Guatemala',
      'Guinea',
      'Guinea-Bissau',
      'Guyana',
      'Haiti',
      'Honduras',
      'Hungary',
      'Iceland',
      'India',
      'Indonesia',
      'Iran',
      'Iraq',
      'Ireland',
      'Israel',
      'Italy',
      'Jamaica',
      'Japan',
      'Jordan',
      'Kazakhstan',
      'Kenya',
      'Kiribati',
      'Kuwait',
      'Kyrgyzstan',
      'Laos',
      'Latvia',
      'Lebanon',
      'Lesotho',
      'Liberia',
      'Libya',
      'Liechtenstein',
      'Lithuania',
      'Luxembourg',
      'Madagascar',
      'Malawi',
      'Malaysia',
      'Maldives',
      'Mali',
      'Malta',
      'Marshall Islands',
      'Mauritania',
      'Mauritius',
      'Mexico',
      'Micronesia',
      'Moldova',
      'Monaco',
      'Mongolia',
      'Montenegro',
      'Morocco',
      'Mozambique',
      'Myanmar',
      'Namibia',
      'Nauru',
      'Nepal',
      'Netherlands',
      'New Zealand',
      'Nicaragua',
      'Niger',
      'Nigeria',
      'North Korea',
      'North Macedonia',
      'Norway',
      'Oman',
      'Pakistan',
      'Palau',
      'Panama',
      'Papua New Guinea',
      'Paraguay',
      'Peru',
      'Philippines',
      'Poland',
      'Portugal',
      'Qatar',
      'Romania',
      'Russia',
      'Rwanda',
      'Saint Kitts and Nevis',
      'Saint Lucia',
      'Saint Vincent and the Grenadines',
      'Samoa',
      'San Marino',
      'São Tomé and Príncipe',
      'Saudi Arabia',
      'Senegal',
      'Serbia',
      'Seychelles',
      'Sierra Leone',
      'Singapore',
      'Slovakia',
      'Slovenia',
      'Solomon Islands',
      'Somalia',
      'South Africa',
      'South Korea',
      'South Sudan',
      'Spain',
      'Sri Lanka',
      'Sudan',
      'Suriname',
      'Sweden',
      'Switzerland',
      'Syria',
      'Taiwan',
      'Tajikistan',
      'Tanzania',
      'Thailand',
      'Timor-Leste',
      'Togo',
      'Tonga',
      'Trinidad and Tobago',
      'Tunisia',
      'Turkey',
      'Turkmenistan',
      'Uganda',
      'Ukraine',
      'United Arab Emirates',
      'United Kingdom',
      'United States',
      'Uruguay',
      'Uzbekistan',
      'Vanuatu',
      'Vatican City',
      'Venezuela',
      'Vietnam',
      'Yemen',
      'Zambia',
      'Zimbabwe'
    ]
  },
  {
    tier: '130',
    class: '1301',
    code: '130106',
    category: 'Issuer Identification',
    subClass: 'Industry',
    label: 'Industry Classification',
    inputType: 'select',
    options: [
      'Energy',
      'Materials',
      'Industrials',
      'Consumer Discretionary',
      'Consumer Staples',
      'Healthcare',
      'Financials',
      'Real Estate',
      'Technology',
      'Communication Services',
      'Utilities',
      'Emerging Industries'
    ]
  },
  {
    tier: '130',
    class: '1301',
    code: '130107',
    category: 'Issuer Identification',
    subClass: 'Sector',
    label: 'Sector / Subsector',
    inputType: 'select',
    options: [
      'Energy — Oil & Gas',
      'Energy — Renewables',
      'Materials — Metals & Mining',
      'Materials — Chemicals',
      'Industrials — Manufacturing',
      'Industrials — Transportation',
      'Consumer Discretionary — Retail',
      'Consumer Discretionary — Leisure',
      'Consumer Staples — Food & Beverage',
      'Consumer Staples — Household Products',
      'Healthcare — Biotech',
      'Healthcare — Medical Devices',
      'Financials — Banking',
      'Financials — Insurance',
      'Real Estate — Residential',
      'Real Estate — Commercial',
      'Technology — Software',
      'Technology — Blockchain',
      'Technology — Artificial Intelligence',
      'Technology — Robotics',
      'Technology — Hardware',
      'Communication Services — Media',
      'Communication Services — Telecom',
      'Utilities — Power',
      'Utilities — Water'
    ]
  },
  {
    tier: '130',
    class: '1301',
    code: '130107',
    category: 'Issuer Identification',
    subClass: 'CID',
    label: 'CID',
    inputType: 'Single-select',
    options: ['Verified', 'Not Verified']
  }
];

/* ================= HISTORICAL ================= */

export const HISTORICAL_TYPE_CODES = [
  {
    tier: '138',
    class: '1381',
    code: '138101',
    category: 'Corporate Actions',
    subClass: 'Token Issuance',
    label: 'Token Issuance Events',
    inputType: 'single-select',
    options: ['Initial Token Issuance', 'Secondary Token Issuance']
  },
  {
    tier: '138',
    class: '1381',
    code: '138102',
    category: 'Corporate Actions',
    subClass: 'Token Burns',
    label: 'Token Burns',
    inputType: 'single-select',
    options: ['Active', 'Inactive']
  },
  {
    tier: '138',
    class: '1381',
    code: '138103',
    category: 'Corporate Actions',
    subClass: 'Token Splits',
    label: 'Token Splits/Reverse Splits',
    inputType: 'single-select',
    options: ['Active', 'Inactive']
  },
  {
    tier: '138',
    class: '1381',
    code: '138104',
    category: 'Corporate Actions',
    subClass: 'Governance Votes',
    label: 'Governance Votes',
    inputType: 'single-select',
    options: ['Active', 'Inactive']
  },
  {
    tier: '138',
    class: '1381',
    code: '138105',
    category: 'Corporate Actions',
    subClass: 'Funding Rounds',
    label: 'Funding Rounds',
    inputType: 'multi-select',
    options: [
      'Seed',
      'Late Seed',
      'Series A',
      'Series A+',
      'Series B',
      'Series B+',
      'Series C',
      'Series C+',
      'Series D',
      'Series E',
      'Growth Equity',
      'Bridge Round'
    ]
  },
  {
    tier: '138',
    class: '1381',
    code: '138106',
    category: 'Corporate Actions',
    subClass: 'M&A',
    label: 'Mergers/Acquisitions',
    inputType: 'single-select',
    options: ['Actively Seeking', 'Completed', 'None']
  },
  {
    tier: '138',
    class: '1381',
    code: '138107',
    category: 'Corporate Actions',
    subClass: 'Restructurings',
    label: 'Restructurings',
    inputType: 'single-select',
    options: ['Yes', 'No']
  },
  {
    tier: '138',
    class: '1381',
    code: '138108',
    category: 'Corporate Actions',
    subClass: 'Redemptions',
    label: 'Redemptions/Buybacks',
    inputType: 'single-select',
    options: ['Active', 'Inactive']
  }
];

/* ================= LEGAL ================= */

export const LEGAL_TYPE_CODES = [
  {
    tier: '141',
    class: '1411',
    code: '141101',
    category: 'Legal',
    subClass: 'Offering Memorandum',
    label: 'Offering Memorandum',
    inputType: 'single-select',
    options: ['Active', 'Inactive']
  },
  {
    tier: '141',
    class: '1411',
    code: '141103',
    category: 'Legal',
    subClass: 'Smart-Contract',
    label: 'Smart-Contract',
    inputType: 'multi-select',
    options: ['PNP16 Token Contract', 'RWA Tokenization Contract']
  },
  {
    tier: '141',
    class: '1411',
    code: '141104',
    category: 'Legal',
    subClass: 'Legal Opinions',
    label: 'Legal Opinions',
    inputType: 'single-select',
    options: ['Active', 'Inactive']
  },
  {
    tier: '141',
    class: '1411',
    code: '141105',
    category: 'Legal',
    subClass: 'Risk Disclosures',
    label: 'Risk Disclosures',
    inputType: 'single-select',
    options: ['Active', 'Inactive']
  },
  {
    tier: '141',
    class: '1411',
    code: '141106',
    category: 'Legal',
    subClass: 'Investor Agreements',
    label: 'Investor Agreements',
    inputType: 'single-select',
    options: ['Active', 'Inactive']
  },
  {
    tier: '141',
    class: '1411',
    code: '141107',
    category: 'Legal',
    subClass: 'Collateral Agreements',
    label: 'Collateral Agreements',
    inputType: 'single-select',
    options: ['Active', 'Inactive']
  }
];

/* ================= TOKEN_DATA ================= */

export const TOKEN_DATA_CODES = [
  {
    tier: '133',
    class: '1331',
    code: '133101',
    category: 'Token Data',
    subClass: 'Issuance Authority',
    label: 'Token Issuance Authority',
    inputType: 'single-select',
    options: [
      'Issuer Board Authorization',
      'Executive Authorization',
      'DAO Governance Vote',
      'Transfer Agent Authroization',
      'Custoidal Bank Authorization',
      'Broker-Dealer Authorization',
      'Trust Company Authorization',
      'Compliance Approved Issuance',
      'Third Party Administrator',
      'Joint issuance Authority'
    ]
  },
  {
    tier: '133',
    class: '1331',
    code: '133102',
    category: 'Token Data',
    subClass: 'Minting Policy',
    label: 'Token Minting Policy',
    inputType: 'single-select',
    options: [
      'Fixed Supply',
      'Capped Supply',
      'Unlimited Supply',
      'Programmatic Miniting',
      'Governance-Approved Minting',
      'Treasury Controlled Minting',
      'Custodian Authroized Minting',
      'Issuer Authorized Minting',
      'Event Triggered Minting',
      'Time Based Minting',
      'Burn and Mint',
      'Emergency Minting'
    ]
  },
  {
    tier: '133',
    class: '1331',
    code: '133103',
    category: 'Token Data',
    subClass: 'Supply',
    label: 'Token Supply (Circulating/Max/Locked)',
    inputType: 'group',
    fields: [
      { label: 'Circulating Supply', inputType: 'text' },
      { label: 'Max Supply', inputType: 'text' },
      { label: 'Locked Supply', inputType: 'text' }
    ]
  },
  {
    tier: '133',
    class: '1331',
    code: '133104',
    category: 'Token Data',
    subClass: 'Treasury',
    label: 'Treasury Holdings',
    inputType: 'single-select',
    options: ['Single Asset DAT', 'Multi-Asset DAT']
  },
  {
    tier: '133',
    class: '1331',
    code: '133105',
    category: 'Token Data',
    subClass: 'Vesting',
    label: 'Token Vesting Schedules',
    inputType: 'single-select',
    options: [
      'No Vesting',
      'Cliff Vesting',
      'Linear Vesting',
      'Monthly Vesting',
      'Quarterly Vesting',
      'Annual Vesting',
      'Custom Time Based',
      'KPI Triggered Vesting',
      'Milestone Trigged Vesting',
      'Product Launch Vesting',
      'Ecosystem Growth Vesting',
      'Hybrid: Cliff + Linear',
      'Hybrid: Cliff + Performance',
      'Hybrid: Time Based + Milestone'
    ]
  },
  {
    tier: '133',
    class: '1331',
    code: '133106',
    category: 'Token Data',
    subClass: 'Buyback Policy',
    label: 'Token Buyback Policy',
    inputType: 'single-select',
    options: ['Active', 'Inactive']
  },
  {
    tier: '133',
    class: '1331',
    code: '133107',
    category: 'Token Data',
    subClass: 'Redemption Rights',
    label: 'Token Redemption Rights',
    inputType: 'single-select',
    options: ['Active', 'Inactive']
  },
  {
    tier: '133',
    class: '1331',
    code: '133108',
    category: 'Token Data',
    subClass: 'Conversion Rights',
    label: 'Token Conversion Rights',
    inputType: 'single-select',
    options: ['Active', 'Inactive']
  },
  {
    tier: '133',
    class: '1331',
    code: '133109',
    category: 'Token Data',
    subClass: 'Governance Rights',
    label: 'Token Governance Rights',
    inputType: 'single-select',
    options: ['Active', 'Inactive']
  }
];

/* ================= PROJECT_DATA ================= */

export const PROJECT_DATA_CODES = [
  {
    tier: '136',
    class: '1361',
    code: '136101',
    category: 'Project Data',
    subClass: 'Project Name',
    label: 'Project Name',
    inputType: 'text'
  },
  {
    tier: '136',
    class: '1361',
    code: '136102',
    category: 'Project Data',
    subClass: 'Project Type',
    label: 'Project Type',
    inputType: 'multi-select',
    options: [
      'Technology Platform',
      'Financial Services / FinTech',
      'Blockchain Infrastructure',
      'Digital Assets / Tokenization',
      'Artificial Intelligence / Data Infrastructure',
      'Energy (Traditional, Renewable, Nuclear)',
      'Mining / Metals / Natural Resources',
      'Manufacturing / Industrial',
      'Logistics / Supply Chain',
      'Real Estate / Infrastructure',
      'Healthcare / Life Sciences',
      'Defense / Aerospace',
      'Consumer Products',
      'Enterprise Software / SaaS',
      'eCommerce / Marketplaces',
      'Media / Communications',
      'AgTech / Food Systems',
      'Climate / Carbon / Sustainability',
      'Mobility / Transportation',
      'Special Situations / Distressed Assets'
    ]
  },
  {
    tier: '136',
    class: '1361',
    code: '136103',
    category: 'Project Data',
    subClass: 'Stage',
    label: 'Project Stage',
    inputType: 'multi-select',
    options: [
      'Concept / Ideation',
      'Pre-Seed',
      'Seed',
      'Early Growth',
      'Growth / Scale-Up',
      'Expansion',
      'Late Stage',
      'Pre-IPO',
      'Public Company',
      'Restructuring / Turnaround',
      'Roll-Up / Consolidation',
      'Mature / Cash-Flowing'
    ]
  },
  {
    tier: '136',
    class: '1361',
    code: '136104',
    category: 'Project Data',
    subClass: 'Budget',
    label: 'Project Budget',
    inputType: 'multi-select',
    options: [
      '$500,000',
      '$1,000,000',
      '$1,500,000',
      '$2,000,000',
      '$2,500,000',
      '$3,000,000',
      '$3,500,000',
      '$4,000,000',
      '$4,500,000',
      '$5,000,000',
      '$7,500,000',
      '$10,000,000',
      '$12,500,000',
      '$15,000,000',
      '$20,000,000',
      '$25,000,000',
      '$30,000,000',
      '$35,000,000',
      '$40,000,000',
      '$45,000,000',
      '$50,000,000',
      '$55,000,000',
      '$60,000,000',
      '$65,000,000',
      '$70,000,000',
      '$75,000,000',
      '$80,000,000',
      '$85,000,000',
      '$90,000,000',
      '$95,000,000',
      '$100,000,000'
    ]
  },
  {
    tier: '136',
    class: '1361',
    code: '136105',
    category: 'Project Data',
    subClass: 'Funding Status',
    label: 'Funding Status',
    inputType: 'multi-select',
    options: [
      'Not Funded',
      'Bootstrapped',
      'Friends & Family',
      'Angel Funded',
      'Seed Funded',
      'Series A',
      'Series B',
      'Series C+',
      'Private Equity Backed',
      'Debt Financed',
      'Hybrid (Debt + Equity)',
      'Grant / Government Funded',
      'Strategic Investor Backed',
      'Fully Funded',
      'Actively Raising',
      'Capital Constrained'
    ]
  },
  {
    tier: '136',
    class: '1361',
    code: '136106',
    category: 'Project Data',
    subClass: 'Revenue Model',
    label: 'Project Revenue Model',
    inputType: 'multi-select',
    options: [
      'Subscription (Recurring Revenue)',
      'Transaction Fees',
      'Licensing',
      'Usage-Based / Metered',
      'SaaS / Platform Fees',
      'Asset Sales',
      'Leasing / Rental',
      'Advertising',
      'Data Monetization',
      'Token-Based Utility',
      'Yield / Interest Spread',
      'Royalty-Based',
      'Performance-Based Fees',
      'Marketplace Commissions',
      'Long-Term Contracts',
      'Offtake Agreements'
    ]
  },
  {
    tier: '136',
    class: '1361',
    code: '136107',
    category: 'Project Data',
    subClass: 'KPIs',
    label: 'Project KPIs',
    inputType: 'single-select',
    options: ['Active', 'Inactive']
  },
  {
    tier: '136',
    class: '1361',
    code: '136108',
    category: 'Project Data',
    subClass: 'Milestones',
    label: 'Project Milestones',
    inputType: 'single-select',
    options: ['Active', 'Inactive']
  },
  {
    tier: '136',
    class: '1361',
    code: '136109',
    category: 'Project Data',
    subClass: 'Risk Assessment',
    label: 'Project Risk Assessment',
    inputType: 'multi-select',
    options: [
      'Very Low Risk',
      'Low Risk',
      'Moderate Risk',
      'Elevated Risk',
      'High Risk',
      'Speculative',
      'Development Risk',
      'Regulatory Risk',
      'Market Adoption Risk',
      'Technology Risk',
      'Capital Risk',
      'Execution Risk',
      'Geopolitical Risk',
      'Commodity / Price Risk'
    ]
  },
  {
    tier: '136',
    class: '1361',
    code: '136110',
    category: 'Project Data',
    subClass: 'Cashflow Forecast',
    label: 'Project Cashflow Forecast',
    inputType: 'single-select',
    options: [
      'Monthly Cashflow Forecast',
      'Quarterly Cashflow Forecast',
      'Annual Cashflow Forecast',
      'Rolling 12-Month Forecast',
      'Base Case Forecast',
      'Upside Case Forecast',
      'Downside Case Forecast',
      'Stress-Test Forecast',
      'Driver-Based Forecast',
      'Project-Based Cashflow Forecast',
      'Free Cashflow Forecast'
    ]
  }
];

/* ================= RISK ================= */

export const RISK_TYPE_CODES = [
  {
    tier: '135',
    class: '1351',
    code: '135101',
    category: 'Risk Profile',
    subClass: 'Credit Grade',
    label: 'Issuer Credit Grade',
    inputType: 'single-select',
    options: [
      'AAA (Exceptional Credit Quality)',
      'AA (Very Strong Credit Quality)',
      'A (Strong Credit Quality)',
      'BBB (Adequate / Investment Grade Threshold)',
      'BB (Speculative but Stable)',
      'B (Highly Speculative)',
      'CCC (Substantial Credit Risk)',
      'CC (Very High Credit Risk)',
      'C (Near Default)',
      'D (In Default)'
    ]
  },
  {
    tier: '135',
    class: '1351',
    code: '135102',
    category: 'Risk Profile',
    subClass: 'Default Risk',
    label: 'Default Risk Score',
    inputType: 'single-select',
    options: [
      'Very Low (≤1%)',
      'Low (1%–3%)',
      'Moderate (3%–7%)',
      'Elevated (7%–15%)',
      'High (15%–30%)',
      'Severe (>30%)'
    ]
  },
  {
    tier: '135',
    class: '1351',
    code: '135103',
    category: 'Risk Profile',
    subClass: 'Liquidity Risk',
    label: 'Liquidity Risk Score',
    inputType: 'single-select',
    options: [
      'Very High Liquidity',
      'High Liquidity',
      'Adequate Liquidity',
      'Moderate Liquidity Risk',
      'Elevated Liquidity Risk',
      'Illiquid / Distressed'
    ]
  },
  {
    tier: '135',
    class: '1351',
    code: '135104',
    category: 'Risk Profile',
    subClass: 'Operational Risk',
    label: 'Operational Risk Score',
    inputType: 'single-select',
    options: [
      'Minimal Operational Risk',
      'Low Operational Risk',
      'Moderate Operational Risk',
      'Elevated Operational Risk',
      'High Operational Risk',
      'Critical Operational Risk'
    ]
  },
  {
    tier: '135',
    class: '1351',
    code: '135105',
    category: 'Risk Profile',
    subClass: 'Smart-Contract Risk',
    label: 'Smart-Contract Risk Score',
    inputType: 'single-select',
    options: [
      'None (No On-Chain Exposure)',
      'Minimal (Audited, Limited Scope)',
      'Low (Audited, Multi-Sig Controls)',
      'Moderate (Complex Logic, Audited)',
      'Elevated (Unaudited or New Code)',
      'High (Critical Vulnerabilities Identified)'
    ]
  },
  {
    tier: '135',
    class: '1351',
    code: '135106',
    category: 'Risk Profile',
    subClass: 'Collateralization',
    label: 'DAT Collateralization Level',
    inputType: 'single-select',
    options: [
      'Over-Collateralized (≥150%)',
      'Strongly Collateralized (120%–149%)',
      'Fully Collateralized (100%–119%)',
      'Marginally Collateralized (80%–99%)',
      'Under-Collateralized (<80%)',
      'Uncollateralized'
    ]
  },
  {
    tier: '135',
    class: '1351',
    code: '135107',
    category: 'Risk Profile',
    subClass: 'Asset Coverage',
    label: 'Asset Coverage Ratio',
    inputType: 'single-select',
    options: [
      '3.0x (Exceptional Coverage)',
      '2.0x–3.0x (Strong Coverage)',
      '1.5x–2.0x (Adequate Coverage)',
      '1.0x–1.5x (Thin Coverage)',
      '<1.0x (Negative Coverage)'
    ]
  },
  {
    tier: '135',
    class: '1351',
    code: '135108',
    category: 'Risk Profile',
    subClass: 'Concentration Risk',
    label: 'Concentration Risk',
    inputType: 'single-select',
    options: [
      'Very Low (Highly Diversified)',
      'Low',
      'Moderate',
      'Elevated',
      'High',
      'Severe (Single-Point Dependency)'
    ]
  },
  {
    tier: '135',
    class: '1351',
    code: '135109',
    category: 'Risk Profile',
    subClass: 'Regulatory Risk',
    label: 'Regulatory Risk Level',
    inputType: 'single-select',
    options: [
      'Minimal (Clear Regulatory Framework)',
      'Low',
      'Moderate',
      'Elevated',
      'High',
      'Severe (Regulatory Uncertainty / Adverse Action Risk)'
    ]
  }
];

/* ================= TREASURY ================= */

export const TREASURY_PROFILE_CODES = [
  /* --- Digital Asset Treasury (selectable + text input) --- */

  {
    tier: '132',
    class: '1321',
    code: '132101',
    category: 'Treasury',
    subClass: 'Digital Asset Treasury',
    label: 'Digital Asset Treasury Key',
    inputType: 'single-select text'
  },
  {
    tier: '132',
    class: '1321',
    code: '132199',
    category: 'Treasury',
    subClass: 'Treasury Type (Unified)',
    label: 'Treasury Type (Select One)',
    inputType: 'single-select',
    options: [
      'RWA-Heavy Treasury',
      'Real Estate Heavy Treasury',
      'BTC-Heavy Treasury',
      'ETH-Heavy Treasury',
      'SOL-Heavy Treasury',
      'PECU-Heavy Treasury',
      'USXM-Heavy Treasury',
      'USDT-Heavy Treasury',
      'Commodity Heavey Treasury',
      'Stablecoin Heavy Treasury',
      'Balanced Multi-Asset Treasury',
      'Volatility-Hedged Treasury',
      'Yield-Optimized Treasury',
      'AUXM-Heavy Treasury',
      'AGXM-Heavy Treasury',
      'PDXM-Heavy Treasury',
      'PTXM-Heavy Treasury',
      'WTXM-Heavy Treasury',
      'BRXM-Heavy Treasury',
      'NGXM-Heavy Treasury',
      'CRXM-Heavy Treasury',
      'GSXM-Heavy Treasury',
      'CCXM-Heavy Treasury',
      'WHXM-Heavy Treasury',
      'CUXM-Heavy Treasury',
      'EUXM-Heavy Treasury',
      'UKXM-Heavy Treasury',
      'JPXM-Heavy Treasury',
      'CDXM-Heavy Treasury',
      'CHXM-Heavy Treasury',
      'CNXM-Heavy Treasury'
    ]
  }
];
